// extracted by mini-css-extract-plugin
module.exports = {"row":"detail_row__2tXPj","label":"detail_label__2OAv5"};